import { IDistrictCreate, IDistrictListSearch, IDistrictSearch, IEditDistrictPayload } from "../../../../types/master/districtInterface";
import api from "../../../../lib/api";

export const getDistrictByIdApi = async (data: IDistrictSearch) => {
  return await api.get(`district/${data.district}`, {
    signal: data.signal,
  });
};

export const createDistrictApi = async (data: IDistrictCreate) => {
  return await api.post(`/district`, data);
};

export const getDistrictListApi = async (data: IDistrictListSearch) => {
  return await api.get(`/district/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const deleteDistrictById = async (districtId: number | string) => {
  return await api.delete(`/district/${districtId}`);
};

export const getDistrictDataByIdApi = async (id: number) => {
  return await api.get(`/district/${id}`)
}

export const editDistrictDataByIdApi = async (payload: IEditDistrictPayload) => {
  return await api.put(`/district/${payload.id}`, payload.data);
};

export const getStateDropdownApi = () => {
  return api.get("/dropdowns/state");
};